import React, { useContext } from 'react'

import { SiteBuilderContext } from '../../../renderer/context/SiteBuilderContext'
import { findItems } from '../../../utils/findItem'
import WithEarlyReturn from '@/utils/WithEarlyReturn'

interface IDynamicContentProps {
  id: string
  content: JSX.Element
}

export interface DynamicContentProps {
  dynamicContent: IDynamicContentProps[]
}

const DynamicContent = ({ dynamicContent }: DynamicContentProps) => {
  const { activeTabIds } = useContext(SiteBuilderContext)
  const activeContent = findItems<IDynamicContentProps>(dynamicContent, activeTabIds)

  return (
    <div data-testid={'dynamic-content-testid'}>
      {activeContent?.length > 0 && activeContent.map((content) => <div key={content.id}>{content.content}</div>)}
    </div>
  )
}

export default WithEarlyReturn(
  DynamicContent,
  'dynamicContent',
  (dynamicContent) => !!dynamicContent && dynamicContent.length > 0,
  'Dynamic Content should not be empty'
)
